// extracted by mini-css-extract-plugin
export default {"heading":"CatalogSectionHeading_heading__d6oPR","label":"CatalogSectionHeading_label__jGUif","rule":"CatalogSectionHeading_rule__CI0M1","aside":"CatalogSectionHeading_aside__oZ25s"};